import { useVistaExperiment } from './useVistaExperiment';

export const INTELLIGENT_STYLES_EXPERIMENT = 'expert_services_intelligent_styles';

export type variants = 'control' | 'test';

export interface Context {
    locale: string;
    esMpvID: string;
    printMpvID: string;
}

const SUPPORTED_LOCALES_AND_PRINT_MPV_IDS: { [key: string]: string[] } = {
    'en-au': ['flyersandleaflets', 'standardbusinesscards'],
    'en-us': ['flyers', 'standardbusinesscards'],
    'en-ca': ['flyers', 'standardbusinesscards'],
};

const SUPPORTED_ES_MPV_ID = 'caredesign';

export function useIntelligentStylesExperiment(context: Context) {
    const supportedLocales = Object.keys(SUPPORTED_LOCALES_AND_PRINT_MPV_IDS);
    const supportedPrintMpvIds =
        SUPPORTED_LOCALES_AND_PRINT_MPV_IDS[context.locale.toLowerCase()] || [];

    const experiment = useVistaExperiment(INTELLIGENT_STYLES_EXPERIMENT, [
        { value: context.esMpvID.toLowerCase(), must: SUPPORTED_ES_MPV_ID },
        { value: context.printMpvID.toLowerCase(), oneOf: supportedPrintMpvIds },
        { value: context.locale.toLowerCase(), oneOf: supportedLocales },
    ]);
    const isEnabled = experiment.variant === 'test';

    return { ...experiment, isEnabled };
}
